export default "__VITE_ASSET__0Dg$uCKz__"